import React from "react"

import IncludedLodging from "~components/pages/listing/checkout/included-lodging"
import CheckoutFlowNavButtons from "~components/pages/listing/checkout/checkout-flow/checkout-flow-nav-buttons"

import CheckoutFlowStep from "./checkout-flow-step"
import CheckoutFlowResources from "./checkout-flow-resources"

export default function CheckoutFlowAccommodationsStep() {
    return (
        <CheckoutFlowStep
            renderNavButtons={() => (
                <CheckoutFlowNavButtons isContinueDisabled={false} />
            )}
        >
            <IncludedLodging />
            <CheckoutFlowResources />
        </CheckoutFlowStep>
    )
}
